import { isPlatformBrowser, Location } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';

@Component({
    selector: 'app-category-pagination',
    templateUrl: './category-pagination.component.html',
    styleUrls: ['./category-pagination.component.scss'],
    standalone: false,
})
export class CategoryPaginationComponent implements OnInit {
    isBrowser: boolean;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private categoryService: CategoryService,
        private routerService: RouterService,
        private location: Location
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit() {}

    get pagination() {
        return this.categoryService.category.pagination;
    }
    get urlComponent() {
        return this.routerService.url.component;
    }

    paginate(paramObj: any) {
        if (!this.isBrowser) {
            return;
        }
        let url = window.location.pathname;
        const searchParams = new URLSearchParams();
        Object.keys(paramObj).forEach((param) => {
            searchParams.set(param, paramObj[param]);
        });
        if (searchParams.toString()) {
            url += '?';
        }
        url += decodeURIComponent(searchParams.toString());
        this.location.go(url);
        this.categoryService.loadPage();
        const categoryBody = document.getElementById('category-body');
        categoryBody.scrollIntoView({
            behavior: 'smooth',
        });
    }
}
